<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105" :class="{'yellow': iconColour == 'yellow'}">
        <path d="M52.71,104.52a52.08,52.08,0,1,1,52.08-52.08A52.14,52.14,0,0,1,52.71,104.52ZM52.71,4a48.49,48.49,0,1,0,48.48,48.48A48.54,48.54,0,0,0,52.71,4Z"/>
        <path d="M80.14,54.24H25.28a1.8,1.8,0,0,1,0-3.59H80.14a1.8,1.8,0,0,1,0,3.59Z" />
        <path d="M52.71,81.66a1.8,1.8,0,0,1-1.8-1.79V25a1.8,1.8,0,1,1,3.6,0V79.87A1.8,1.8,0,0,1,52.71,81.66Z" />
    </svg>
</template>

<style lang="scss" scoped>
    path {
        fill: $colour__primary1;
        .yellow & {
            fill: $colour__accent1;
        }
    }
</style>

<script>
export default {
    name: 'PlusCircleIcon',
    props: ['iconColour']
}
</script>
